module.exports = __webpack_public_path__ + "static/media/SUNPHARMA.986289b7.txt";